import { Routes } from '@angular/router';
import { PageComponent } from './components/page/page.component';
import { pageResolver } from './resolvers/page.resolver';
import { EventInfoComponent } from './components/event-info/event-info.component';
import { eventResolver } from './resolvers/event.resolver';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'nl/home' },
  { path: ':language/event/:event', component: EventInfoComponent, resolve: { event: eventResolver } },
  { path: ':language/:page', component: PageComponent, resolve: pageResolver }
];